import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import SplashScreen from '@/screens/SplashScreen'
// import ErrorScreen from '@/screens/ErrorScreen'

import StackScreen from '@/screens/StackScreen'

// -----------------------------------------------------------------------------

import StartScreen from '@/screens/Public/StartScreen'

import SignInScreen from '@/screens/Public/Auth/SignInScreen'

import PrivacyScreen from '@/screens/Public/PrivacyScreen'

// -----------------------------------------------------------------------------

const HomeTabScreen = () => import('@/screens/Home/HomeTabScreen')

const StationScreen = () => import('@/screens/Home/Station/StationScreen')
const StationOnlineOrder = () => import('@/screens/Home/Station/StationOnlineOrder')

const GarageScreen = () => import('@/screens/Home/Garage/GarageScreen')
const GarageCarScreen = () => import('@/screens/Home/Garage/GarageCarScreen')
const GarageCarEditScreen = () => import('@/screens/Home/Garage/GarageCarEditScreen')

const BonusScreen = () => import('@/screens/Home/Bonus/BonusScreen')

const PromoScreen = () => import('@/screens/Home/Promo/PromoScreen')
const PromoDetailScreen = () => import('@/screens/Home/Promo/PromoDetailScreen')

const StationAddressScreen = () => import('@/screens/Home/StationAddress/StationAddressScreen')

const HistoryScreen = () => import('@/screens/Home/History/HistoryScreen')
const HistoryFeedbackScreen = () => import('@/screens/Home/History/HistoryFeedbackScreen')

// -----------------------------------------------------------------------------

const stationStack = [
    {
        path: 'station',
        component: StackScreen,
        children: [
            {
                path: '/home/station',
                name: 'Station',
                component: StationScreen,
                meta: {
                    showTopMenu: true,
                    appBar: {
                        title: 'Станция ТО',
                        navigationIcon: {
                            type: 'nav',
                        },
                    },
                },
            },
            {
                path: 'online-order',
                name: 'StationOnlineOrder',
                component: StationOnlineOrder,
                meta: {
                    //
                },
            },
        ],
    },
]

const garageStack = [
    {
        path: 'garage',
        component: StackScreen,
        children: [
            {
                path: '/home/garage',
                name: 'Garage',
                component: GarageScreen,
                meta: {
                    showTopMenu: true,
                    appBar: {
                        title: 'Гараж',
                        navigationIcon: {
                            type: 'nav',
                        },
                    },
                },
            },
            {
                path: 'car/view/:carId',
                name: 'GarageCarView',
                component: GarageCarScreen,
                meta: {
                    // showTopMenu: true,
                    appBar: {
                        title: 'Автомобиль',
                        navigationIcon: {
                            type: 'back',
                        },
                    },
                },
            },
            {
                path: 'car/edit/:carId?',
                name: 'GarageCarEdit',
                component: GarageCarEditScreen,
                meta: {
                    pageTitle: 'Добавить автомобиль',
                    appBar: {
                        title: 'Автомобиль',
                        navigationIcon: {
                            type: 'back',
                        },
                    },
                },
            },
        ],
    },
]

const promoStack = [
    {
        path: 'promo',
        component: StackScreen,
        children: [
            {
                path: '/home/promo',
                name: 'Promo',
                component: PromoScreen,
                meta: {
                    showTopMenu: true,
                    appBar: {
                        title: 'Акции',
                        navigationIcon: {
                            type: 'nav',
                        },
                    },
                },
            },
            {
                path: 'detail/:promotionId',
                name: 'PromoDetail',
                component: PromoDetailScreen,
                meta: {
                    appBar: {
                        title: 'Акция',
                        navigationIcon: {
                            type: 'back',
                        },
                    },
                },
            },
        ],
    },
]

const stationAddressStack = [
    {
        path: 'station-address',
        component: StackScreen,
        children: [
            {
                path: '/home/station-address',
                name: 'StationAddress',
                component: StationAddressScreen,
                meta: {
                    showTopMenu: true,
                    appBar: {
                        title: 'Адреса СТО',
                        navigationIcon: {
                            type: 'nav',
                        },
                    },
                },
            },
        ],
    },
]

const bonusStack = [
    {
        path: 'bonus',
        component: StackScreen,
        children: [
            {
                path: '/home/bonus',
                name: 'Bonus',
                component: BonusScreen,
                meta: {
                    appBar: {
                        title: 'Бонусы',
                        navigationIcon: {
                            type: 'nav',
                        },
                    },
                },
            },
        ],
    },
]

const historyStack = [
    {
        path: 'history',
        component: StackScreen,
        children: [
            {
                path: '/home/history',
                name: 'History',
                component: HistoryScreen,
                meta: {
                    showTopMenu: true,
                    appBar: {
                        title: 'История обслуживания',
                        navigationIcon: {
                            type: 'nav',
                        },
                    },
                },
            },
            {
                path: ':orderId',
                component: StackScreen,
                children: [
                    {
                        path: 'feedback',
                        name: 'HistoryFeedback',
                        component: HistoryFeedbackScreen,
                        meta: {
                            appBar: {
                                title: 'Отзыв',
                                navigationIcon: {
                                    type: 'back',
                                },
                            },
                        },
                    },
                ],
            },
        ],
    },
]

const publicStationAddressStack = [
    {
        path: 'station-address',
        component: StackScreen,
        children: [
            {
                path: '/home/station-address',
                name: 'PublicStationAddress',
                component: StationAddressScreen,
                meta: {
                    appBar: {
                        title: 'Адреса СТО',
                        navigationIcon: {
                            type: 'nav',
                        },
                    },
                },
            },
        ],
    },
]

// -----------------------------------------------------------------------------

const authStack = [
    {
        path: 'auth',
        name: 'Auth',
        component: StackScreen,
        redirect: { name: 'SignIn' },
        children: [
            {
                path: 'sign-in',
                name: 'SignIn',
                component: SignInScreen,
                meta: {
                    appBar: {
                        title: 'Авторизация',
                        navigationIcon: {
                            type: 'back',
                        },
                    },
                },
            },
        ],
    },
]

const publicStack = [
    {
        path: '/public',
        name: 'Public',
        component: StackScreen,
        redirect: { name: 'Start' },
        children: [
            {
                path: 'start',
                name: 'Start',
                component: StartScreen,
                meta: {
                    appBar: {
                        navigationIcon: {
                            type: 'nav',
                        },
                    },
                },
            },
            {
                path: 'privacy',
                name: 'PublicPrivacy',
                component: PrivacyScreen,
                meta: {
                    appBar: {
                        title: 'Политика конфиденциальности',
                        navigationIcon: {
                            type: 'back',
                        },
                    },
                },
            },
            ...authStack,
            ...publicStationAddressStack,
        ],
    },
]

const homeTab = [
    {
        path: '/home',
        name: 'Home',
        component: HomeTabScreen,
        redirect: { name: 'Station' },
        children: [
            {
                path: 'privacy',
                name: 'Privacy',
                component: PrivacyScreen,
                meta: {
                    appBar: {
                        title: 'Политика конфиденциальности',
                        navigationIcon: {
                            type: 'nav',
                        },
                    },
                },
            },
            ...stationStack,
            ...garageStack,
            ...promoStack,
            //
            ...stationAddressStack,
            ...bonusStack,
            ...historyStack,
        ],
    },
]

// -----------------------------------------------------------------------------

const routes = [
    // {
    //     path: '/',
    //     name: 'Splash',
    //     component: SplashScreen,
    //     meta: {
    //         //
    //     },
    // },
    ...publicStack,
    ...homeTab,
    {
        path: '*',
        name: 'Splash',
        component: SplashScreen,
    },
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
    })
}

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: '/pwa/',
    routes,
})

router.beforeEach((to, from, next) => {
    const isBootstrap = !from.name
    const isSplashScreen = to.name === 'Splash'

    store.commit('ui/setAppBar', to.meta?.appBar || {})

    // Next
    if (isBootstrap) {
        if (isSplashScreen) {
            // Open Splash Screen
            next()
        } else {
            // Push to Splash Screen with redirect params
            next({ name: 'Splash', params: { nextRoute: to || {} } })
        }
    } else {
    // Other Screen
        next()
    }
})

export default router
